module.exports = __webpack_public_path__ + "static/media/close.4c8440d8.svg";